import { headerCellFactory } from 'app/common/components/table';
import theme from './date-header-cell.module.css';

export default headerCellFactory(theme.dateHeader);
